const seatInfoFormatter = (section, row, seat, t) => {
  const secRowSeat = t(`Section`) + ` ${section}, ` + t(`row`) + ` ${row}, ` + t(`seat`) + ` ${seat}`;
  const secSeat = t(`Section`) + ` ${section}, ` + t(`seat`) + ` ${seat}`;
  const rowSeat = t(`Row`) + ` ${row},` + t(`seat`) + ` ${seat}`;
  const seatStr = t(`Seat`) + ` ${seat}`;

  if (section && row && seat) return secRowSeat;
  else if (row && seat) return rowSeat;
  else if (section && seat) return secSeat;
  else return seatStr;
};

export const seatIdToSectionParentOwn = (id, section, parent, own, t) => {
  if (!id) return;
  // NOTE: this crap is here only for backwards compatibility, maybe in the future it can be removed
  let [parsedSect, parsedParen, parsedOwn] = id.split('-');
  if (!parsedOwn) {
    parsedOwn = parsedParen;
    parsedParen = null;
  }

  if (section || parent || own) {
    parsedSect = section;
    parsedParen = parent;
    parsedOwn = own;
  }

  return seatInfoFormatter(parsedSect, parsedParen, parsedOwn, t);
};

export const priceFormatter = (price) => price.toFixed(2) + ' Lei';

export default seatInfoFormatter;
